import React, { useEffect, useState, useRef } from 'react';

import { useLocation } from 'react-router-dom';
import axios from 'axios';
import FlightResult from './FlightResult';
import Spinner from '../Spinner';
import Filter1 from './Filter';
import FlightLoader from './FlightLoader';
import { useSelector } from 'react-redux';

const FlightSearch = () => {
 
  const [flightData, setFlightData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const data = location.state;
  const selectedOption = useSelector((state) => state.option.selectedOption);
  console.log(selectedOption);
  // const selectedOptionRef = useRef('PRICE');
  // console.log(selectedOptionRef)
  
  useEffect(() => {
    const fetchData = async () => {
      const options = {
        method: "GET",
        url: "https://tripadvisor16.p.rapidapi.com/api/v1/flights/searchFlights",
        params: {
          sourceAirportCode: data.from,
          destinationAirportCode: data.to,
          date: data.departure_date,
          itineraryType: data.type,
          sortOrder: selectedOption,
          numAdults: data.adults,
          numSeniors: data.seniors,
          classOfService: data.class,
          pageNumber: "1",
          currencyCode: "USD",
        },
        headers: {
          'X-RapidAPI-Key': 'd838e14b64msh4aef029555603b9p1f8190jsn5d82f7218345',
          'X-RapidAPI-Host': 'tripadvisor16.p.rapidapi.com'
        },
      };

      try {
        setLoading(true); 
        const response = await axios.request(options);
        console.log(response.data.data.flights);
        setFlightData(response.data.data.flights);
        setLoading(false); 
      } catch (error) {
        console.error(error);
        setLoading(false); 
      }
    };
    // const handleOptionSelect = (option) => {
      // Perform actions with the selected option
      // console.log('Selected Option:', option);
      // Send the option to another component or perform any other logic
    // };

    fetchData();
  }, [selectedOption]);

  return (
    <>
      {loading ? (
        <FlightLoader />
      ) : (
        <>
        <FlightResult flights={flightData} />
         {/* <Filter1 onOptionSelect={handleOptionSelect} /> */}
         </>
        
        
      )}
    </>
  );
}

export default FlightSearch;
